<h2 mat-dialog-title class="display-template-dialog-title">{{'contentTypes.displayTemplate' | translate}}</h2>

<mat-dialog-content class="display-template-dialog-content">
  <div class="display-template-editor pt-2 pb-3">
    <section class="template-intro">
      <div class="intro-icon"><mat-icon>dashboard_customize</mat-icon></div>
      <div>
        <strong>{{'contentTypes.displayTemplateDescription' | translate}}</strong>
        <p>{{'contentTypes.displayTemplateDataNote' | translate}}</p>
      </div>
    </section>

    @if (allSections.length > 0) {
      <section class="display-template-actions" aria-label="Display template actions">
        <button mat-button class="secondary-gray-button" [matMenuTriggerFor]="tracerTemplateMenu" [disabled]="!contentTypeUserRights_update" [matTooltip]="'contentTypes.displayTemplateImportHint' | translate">
          <mat-icon>file_upload</mat-icon> {{'contentTypes.importFromTracerTemplate' | translate}}
        </button>
        <button mat-button class="orange-button" (click)="addSection()" [disabled]="!contentTypeUserRights_update">
          <mat-icon>add</mat-icon> {{'contentTypes.addSection' | translate}}
        </button>
      </section>
    }

    <mat-menu #tracerTemplateMenu="matMenu">
      @if (allTaskTemplates.length === 0) {
        <div class="px-4 py-2 text-muted">{{'contentTypes.noTracerTemplates' | translate}}</div>
      }
      @for (template of allTaskTemplates; track template) {
        <button mat-menu-item (click)="importFromTracerTemplate(template)">
          <mat-icon>description</mat-icon> {{template.title}}
        </button>
      }
    </mat-menu>

    <section class="display-template-list">
      @if (allSections.length > 0) {
        <div class="display-template-list-header">
          <span>{{'contentTypes.displayTemplateSection' | translate}}</span>
          <span>{{'contentTypes.displayTemplateFields' | translate}}</span>
        </div>
      }
      @if (allSections.length === 0) {
        <div class="display-template-empty-state">
          <mat-icon>dashboard_customize</mat-icon>
          <h3>{{'contentTypes.displayTemplateEmptyTitle' | translate}}</h3>
          <p>{{'contentTypes.displayTemplateEmptyDescription' | translate}}</p>
          <div>
            <button mat-button class="secondary-gray-button" [matMenuTriggerFor]="tracerTemplateMenu" [disabled]="!contentTypeUserRights_update" [matTooltip]="'contentTypes.displayTemplateImportHint' | translate">
              <mat-icon>file_upload</mat-icon> {{'contentTypes.importFromTracerTemplate' | translate}}
            </button>
            <button mat-button class="orange-button" (click)="addSection()" [disabled]="!contentTypeUserRights_update">
              <mat-icon>add</mat-icon> {{'contentTypes.addSection' | translate}}
            </button>
          </div>
        </div>
      }

      <mat-accordion class="form-field-section" multi cdkDropList (cdkDropListDropped)="dropPanel($event)">
        @for (section of allSections; track section; let index = $index) {
          <mat-expansion-panel cdkDrag [expanded]="index === 0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="drag-handle" cdkDragHandle [matTooltip]="'contentTypes.dragToReorder' | translate" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                <span id="truncate-text">{{section.title}}</span>
              </mat-panel-title>
              <mat-panel-description>
                <span class="section-field-count">{{section.fields?.length || 0}} {{'contentTypes.displayTemplateFields' | translate}}</span>
                <button mat-icon-button [matMenuTriggerFor]="editDelete" style="color:var(--warmOrange);" (click)="$event.stopPropagation()"><mat-icon>more_vert</mat-icon></button>
                <mat-menu #editDelete="matMenu">
                  <button mat-menu-item (click)="editTitleSection(section.title, index)" [disabled]="!contentTypeUserRights_update"><mat-icon>edit</mat-icon> {{'taskTemplates.editSectionTitle' | translate}}</button>
                  <button mat-menu-item (click)="duplicateSection(section, index)" [disabled]="!contentTypeUserRights_update"><mat-icon>content_copy</mat-icon> {{'taskTemplates.duplicateSection' | translate}}</button>
                  <button mat-menu-item (click)="deleteSection(section.title, index)" [disabled]="!contentTypeUserRights_update"><mat-icon class="material-symbols-outlined delete">delete</mat-icon> {{'taskTemplates.deleteSection' | translate}}</button>
                </mat-menu>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="expansion-panel-content">
              <div cdkDropList class="shadow-sm rounded" (cdkDropListDropped)="drop($event, index)">
                @for (item of section.fields; track item; let fieldNumber = $index) {
                  <div cdkDrag id="fields-list" (click)="openFieldDialog(item, fieldNumber, index)" class="d-flex field-row">
                    <div class="d-flex flex-row flex-nowrap">
                      <mat-icon class="drag-handle field-drag-handle" cdkDragHandle [matTooltip]="'contentTypes.dragToReorder' | translate">drag_indicator</mat-icon>
                      @if (item.type === 'boolean') { <span class="material-symbols-outlined p-2 text-orange">toggle_on</span> }
                      @if (item.type === 'currency') { <span class="material-symbols-outlined p-2 text-orange">euro</span> }
                      @if (item.type === 'dateTime') { <span class="material-symbols-outlined p-2 text-orange">calendar_month</span> }
                      @if (item.type === 'date') { <span class="material-symbols-outlined p-2 text-orange">calendar_today</span> }
                      @if (item.type === 'time') { <span class="material-symbols-outlined p-2 text-orange">access_time</span> }
                      @if (item.type === 'decimal') { <span class="material-symbols-outlined p-2 text-orange">numbers</span> }
                      @if (item.type === 'longText') { <span class="material-symbols-outlined p-2 text-orange">subject</span> }
                      @if (item.type === 'number') { <span class="material-symbols-outlined p-2 text-orange">pin</span> }
                      @if (item.type === 'text') { <span class="material-symbols-outlined p-2 text-orange">text_format</span> }
                      @if (item.type === 'weight') { <span class="material-symbols-outlined p-2 text-orange">weight</span> }
                      @if (item.type === 'document') { <span class="material-symbols-outlined p-2 text-orange">attach_file</span> }
                      @if (item.type === 'showImage') { <span class="material-symbols-outlined p-2 text-orange">image</span> }
                      <div class="d-flex flex-column justify-content-center">
                        <span class="text-break text-wrap">{{item.title}}</span>
                        <span class="text-muted text-break text-wrap field-key">{{item.key}}</span>
                      </div>
                    </div>
                    <button mat-icon-button [disabled]="!contentTypeUserRights_update" (click)="$event.stopPropagation(); deleteFieldOfSection(fieldNumber, index)" [matTooltip]="'delete' | translate" class="delete-icon"><span class="material-symbols-outlined">delete</span></button>
                  </div>
                }
              </div>

              <mat-action-row>
                <div [matTooltip]="!contentTypeUserRights_update ? ('home.tooltip' | translate) : null">
                  <button mat-button class="secondary-gray-button m-1" [matMenuTriggerFor]="fieldTypes" [disabled]="!contentTypeUserRights_update"><mat-icon>add_circle</mat-icon> {{'workTask.addNewElement' | translate}}</button>
                  <mat-menu #fieldTypes="matMenu" xPosition="before" yPosition="below">
                    @for (element of elementsOptions; track element) {
                      <button mat-menu-item (click)="addFieldToSection(element.type, index)" [disabled]="!contentTypeUserRights_update"><mat-icon class="material-symbols-outlined text-orange">{{element.icon}}</mat-icon> {{element.translations | translate}}</button>
                    }
                  </mat-menu>
                </div>
              </mat-action-row>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </section>

    <section class="template-tools mt-4">
      <div>
        <h3 class="template-tools-title mb-1">{{'contentTypes.displayTemplateTools' | translate}}</h3>
        <p class="mb-0">{{'contentTypes.createReportTemplateHint' | translate}}</p>
      </div>
      <button mat-button class="secondary-gray-button" (click)="createReportTemplate()" [disabled]="!savedData" [matTooltip]="!savedData ? ('contentTypes.saveTemplateBeforeReport' | translate) : null"><mat-icon>receipt_long</mat-icon> {{'contentTypes.createReportFromTemplate' | translate}}</button>
    </section>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancel()">{{'cancel' | translate}}</button>
  <span [matTooltip]="hasEmptySections() ? ('contentTypes.emptySectionsCannotBeSaved' | translate) : null">
    <button mat-button class="orange-button" (click)="onSave()" [disabled]="hasEmptySections()">{{'apply' | translate}}</button>
  </span>
</mat-dialog-actions>
